import { Link } from "office-ui-fabric-react";

const OktaAuthenticationSettingsTooltip = () =>
    <div>
        Set up the Okta authentication for your PPM Express tenant.<br/>
        Please refer to the <Link href="https://help.ppm.express/89502-ppm-express-how-to-articles/how-to-set-up-okta-authentication" target="_blank">article</Link> for more details.
    </div>

export default OktaAuthenticationSettingsTooltip;